import { AbstractControl, ValidationErrors } from '@angular/forms';

export function requiredProject(control: AbstractControl): ValidationErrors | null {
  const v = control.value;

  if (!v) return { required: true };
  const allEmpty =
    (!v.codigo_proyecto || v.codigo_proyecto === '') &&
    (!v.codigo_proyecto_solicitud || v.codigo_proyecto_solicitud === '') &&
    (!v.proyecto || v.proyecto === '') &&
    (!v.codigo_organismo || v.codigo_organismo === '');

  return allEmpty ? { required: true } : null;
}
